import { render, staticRenderFns } from "./batchGrant.vue?vue&type=template&id=59f2113c&"
import script from "./batchGrant.vue?vue&type=script&lang=ts&"
export * from "./batchGrant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports